module.exports = __webpack_public_path__ + "static/private_office_5-b1b65a5b7a1ebc4d3a971caa9caec4c2.jpg";